module.exports = __webpack_public_path__ + "img/cavalier-challenge-smoke_5ecae54cf6f2a4464b764caa120256e1.gif";


//////////////////
// WEBPACK FOOTER
// ./client/img/cavalier-challenge-smoke.gif
// module id = 263
// module chunks = 0